@if (isSpecialOfferSignal()) {
  <section
    class="w-full h-fit p-2 sm:p-3 md:p-4 lg:p-5 flex flex-col items-center justify-center my-5 md:my-10 md:my-16 lg:my-24">
    <div class="w-full text-center my-10">
      <h1 class="font-secondary text-center font-bold text-secondary-800 text-8xl md:text-12xl lg:text-18xl">
        Oferta <br> <span class="text-primary-600">specjalna</span>
      </h1>
    </div>
    <div class="w-full sm:w-[98%] md:w-[95%] lg:w-[90%] xl:max-w-[1500px]">
      <p-carousel
        ngSkipHydration
        [value]="(auctions$ | async) ?? []"
        [numVisible]="3"
        [numScroll]="1"
        [responsiveOptions]="responsiveOptions"
        (onPage)="onPageEvent($event)"
      >
        <ng-template let-auction #item>
          <div class="h-full sm:p-1 lg:p-2 min-[1400px]:p-5 flex">
            <div
              class="group relative w-full h-full
                   bg-white rounded-2xl sm:rounded-3xl sm:shadow-sm sm:hover:shadow-md transition-all duration-500 overflow-hidden
                   flex flex-col sm:hover:-translate-y-1">
              <div
                class="relative h-48 sm:h-52 md:h-56 lg:h-72 overflow-hidden rounded-t-2xl sm:rounded-t-3xl
                     bg-gradient-to-br from-gray-100 to-gray-200">
                <img
                  [src]="getImageUrl(auction.id, auction.pictures[1].fileId)"
                  [alt]="auction.name"
                  class="w-full h-full object-cover transform transition-transform duration-700
                       group-hover:scale-110"
                />
                @let offerDaysLeft = auctionEndingInfoResolver(auction.metadata.offering.endingDate).daysLeft;
                @let accent = auctionEndingInfoResolver(auction.metadata.offering.endingDate).accent;
                <div
                  class="absolute top-2 right-2 sm:top-3 sm:right-3 lg:top-4 lg:right-4 bg-white/95 backdrop-blur-sm
                       px-2 py-1 sm:px-3 sm:py-1.5 lg:px-4 lg:py-2 rounded-full shadow-md flex flex-row items-center gap-1"
                  [ngClass]="accent">
                  <ng-icon name="matTimerOutline" class="text-xs sm:text-sm"></ng-icon>
                  <span class="text-xs sm:text-sm font-semibold">{{ offerDaysLeft }}</span>
                </div>
              </div>

              <div class="p-3 sm:p-4 lg:p-5 space-y-3 sm:space-y-3.5 lg:space-y-4 flex-1 flex flex-col">
                <div class="space-y-0.5 sm:space-y-1">
                  <h3
                    class="text-base sm:text-lg lg:text-xl font-bold text-gray-900 tracking-tight min-h-[2.5em] leading-tight"
                    style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
                    {{ auction.name }}
                  </h3>
                  <div class="flex items-center gap-0.5 sm:gap-1 text-xs sm:text-sm text-gray-500">
                    <ng-icon name="matLocationOnOutline" class="text-xs sm:text-sm"></ng-icon>
                    <span
                      class="truncate">{{ auction.itemLocation.city + ", " + auction.itemLocation.voivodeship }}</span>
                  </div>
                </div>

                <div class="grid grid-cols-2 gap-2 sm:gap-2.5 lg:gap-3">
                  <div
                    class="flex items-center gap-2 sm:gap-2.5 lg:gap-3 p-2 sm:p-2.5 lg:p-3
                         bg-gray-50 rounded-xl sm:rounded-2xl">
                    <div
                      class="w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10
                           bg-blue-100 text-blue-600 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0">
                      <ng-icon name="tablerRoad" class="text-sm sm:text-base"></ng-icon>
                    </div>
                    <div class="min-w-0">
                      <p class="text-[10px] sm:text-xs text-gray-500">Przebieg</p>
                      <p class="text-xs sm:text-sm text-gray-900 truncate">
                        {{ auction.propertyValues.ENGINE_MILEAGE }} km
                      </p>
                    </div>
                  </div>
                  <div
                    class="flex items-center gap-2 sm:gap-2.5 lg:gap-3 p-2 sm:p-2.5 lg:p-3
                         bg-gray-50 rounded-xl sm:rounded-2xl">
                    <div
                      class="w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10
                           bg-green-100 text-green-600 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0">
                      <ng-icon name="matLocalGasStationOutline" class="text-sm sm:text-base"></ng-icon>
                    </div>
                    <div class="min-w-0">
                      <p class="text-[10px] sm:text-xs text-gray-500">Napęd</p>
                      <p class="text-xs sm:text-sm text-gray-900 truncate">
                        {{ auction.propertyValues.FUEL_TYPE }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="space-y-2 sm:space-y-2.5 lg:space-y-3 pt-1 sm:pt-1.5 lg:pt-2 card-spec">
                  <div
                    class="grid grid-cols-2 gap-x-3 sm:gap-x-3.5 lg:gap-x-4 gap-y-2 sm:gap-y-2.5 lg:gap-y-3">
                    <div class="flex items-center gap-1.5 sm:gap-2">
                      <ng-icon
                        name="phosphorEngineBold"
                        class="text-red-500 text-xs sm:text-sm flex-shrink-0"
                      ></ng-icon>
                      <span class="text-[11px] sm:text-xs lg:text-sm text-gray-900 truncate">
                      {{ auction.propertyValues.POWER_HP }} KM | {{ auction.propertyValues.DISPLACEMENT }} cm³
                    </span>
                    </div>
                    <div class="flex items-center gap-1.5 sm:gap-2">
                      <ng-icon
                        name="matFactoryOutline"
                        class="text-gray-400 text-xs sm:text-sm flex-shrink-0"
                      ></ng-icon>
                      <span class="text-[11px] sm:text-xs lg:text-sm text-gray-600 truncate">
                      {{ auction.propertyValues.YEAR_OF_PRODUCTION }}
                    </span>
                    </div>
                    <div class="flex items-center gap-1.5 sm:gap-2">
                      <ng-icon
                        name="tablerManualGearbox"
                        class="text-gray-400 text-xs sm:text-sm flex-shrink-0"
                      ></ng-icon>
                      <span class="text-[11px] sm:text-xs lg:text-sm text-gray-600 truncate">
                      {{ auction.propertyValues.TRANSMISSION_TYPE }}
                    </span>
                    </div>
                    <div class="flex items-center gap-1.5 sm:gap-2">
                      <ng-icon
                        name="matGroups2Outline"
                        class="text-gray-400 text-xs sm:text-sm flex-shrink-0"
                      ></ng-icon>
                      <span class="text-[11px] sm:text-xs lg:text-sm text-gray-600">
                      <span class="font-semibold text-gray-900">
                        {{ auction.propertyValues.NUMBER_OF_SEATS }}
                      </span>
                      miejsc
                    </span>
                    </div>
                  </div>
                </div>
                <div
                  class="pt-2 sm:pt-2.5 lg:pt-3 border-t border-gray-100 space-y-2 sm:space-y-2.5 lg:space-y-3 mt-auto">
                  <div class="flex items-baseline gap-1.5 sm:gap-2">
                  <span class="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
                    {{ auction.metadata.offering.specialOffer.installment }}
                  </span>
                    <span class="text-xs sm:text-sm text-gray-500">zł/mies.</span>
                  </div>
                  <div class="text-[10px] sm:text-xs text-gray-500">
                    Wpłata początkowa:
                    <span class="font-semibold text-gray-700">
                    {{ auction.metadata.offering.specialOffer.initialFee }} zł
                  </span>
                  </div>
                  <div class="w-full h-auto flex flex-row items-center justify-center gap-2">
                    <button (click)="onCarSelected(auction)"
                            class="w-full bg-gradient-to-r from-blue-600 to-blue-700
                         hover:from-blue-700 hover:to-blue-800 text-white font-semibold
                         py-2.5 sm:py-3 lg:py-3 px-4 sm:px-5 rounded-xl sm:rounded-2xl shadow-lg
                         hoverable-shadow transition-all duration-300 flex items-center justify-center
                         gap-1.5 sm:gap-2 hover:gap-3 sm:hover:gap-4 text-sm sm:text-base">
                      <span>Aplikuj</span>
                      <ng-icon name="matArrowForwardRound"></ng-icon>
                    </button>
                    <button
                      (click)="onDetailsNavigation(auction)"
                      class="w-full bg-gradient-to-r from-primary-50 to-primary-100
                         hover:from-primary-100 hover:to-primary-200 text-primary-500 ring-2 ring-primary-500 font-semibold
                         py-2.5 sm:py-3 lg:py-3 px-4 sm:px-5 rounded-xl sm:rounded-2xl shadow-lg
                         hoverable-shadow transition-all duration-300 flex items-center justify-center
                         gap-1.5 sm:gap-2 hover:gap-3 sm:hover:gap-4 text-sm sm:text-base">
                      <span>Szczegóły</span>
                      <ng-icon name="phosphorGlobe"></ng-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>
    @if (isBrowser && selectedCarData && isModalOpen()) {
      <app-auctions-offer-modal
        [carData]="selectedCarData!"
        (formSubmit)="onSubmit($event)"
        (modalClose)="onClose()">
      </app-auctions-offer-modal>
    }
  </section>
}
